import { PresentationTemplate, templatesMatchingPageFormat } from '../types';

export function kitsForLayoutTarget(
  templates: PresentationTemplate[],
  pageFormat?: string | null,
  excludeId?: string | null,
): PresentationTemplate[] {
  return templatesMatchingPageFormat(templates, pageFormat)
    .filter((template) => template.isActive !== false)
    .filter((template) => !excludeId || template._id !== excludeId);
}
